import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTasksModalComponent } from './add-tasks-modal/add-tasks-modal.component';
import { AgendaModalComponent } from './agenda-modal/agenda-modal.component';
import { AvailableScheduleModalComponent } from './available-schedule-modal/available-schedule-modal.component';
import { ConfirmationTaskModalComponent } from './confirmation-task-modal/confirmation-task-modal.component';
import { DashboardMenuComponent } from './dashboard-menu/dashboard-menu.component';
import { ShowAllAppointmentsModalComponent } from './show-all-appointments-modal/show-all-appointments-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgendaConsultaComponent } from './agenda-consulta/agenda-consulta.component';
import { AgendaBloqueioComponent } from './agenda-bloqueio/agenda-bloqueio.component';
import { AgendaExcecaoComponent } from './agenda-excecao/agenda-excecao.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgendaModalSidebarComponent } from './agenda-modal-sidebar/agenda-modal-sidebar.component';
import { SplitFullCalendarComponent } from 'src/app/shared/components/split-full-calendar/split-full-calendar.component';




@NgModule({
  declarations: [
    AddTasksModalComponent,
    AgendaModalComponent,
    AvailableScheduleModalComponent,
    ConfirmationTaskModalComponent,
    DashboardMenuComponent,
    ShowAllAppointmentsModalComponent,
    AgendaConsultaComponent,
    AgendaBloqueioComponent,
    AgendaExcecaoComponent,
    AgendaModalSidebarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  exports: [
    DashboardMenuComponent
  ]
})
export class DashboardModule { }
